<template>
  <div v-html="displayData" />
</template>
<script>
import { mapGetters } from 'vuex'
import { displayDataInConfigs } from './helpers'
export default {
  props: { data: Array, type: String },
  computed: {
    ...mapGetters({ configs: 'leadConfig/configs' }),
    displayData() {
      return displayDataInConfigs({ configs: this.configs, type: this.type, data: this.data })
    },
  },
}
</script>